import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_EXPORT_SERVICE = createFcmDetails('export_service', {
	owner: 'Site Platform',
	context: 'Signature export',
	description: 'Used to disable signature export capability in case of maintenance',
	import: false,
});
